import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import BulkOperationResultModal from './modal';

@modal(
  {
    className: 'operation-result-modal',
  },
  true,
)
class BulkOperationResultContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <BulkOperationResultModal
        onClose={this.props.handleCloseModal}
        onSuccess={this.props.onSuccess}
        handlePromise={this.props.handlePromise}
        label={this.props.label}
      />
    );
  }
}

BulkOperationResultContainer.propTypes = {
  t: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  label: PropTypes.object.isRequired,
  glitchDetail: PropTypes.func,
  handlePromise: PropTypes.func.isRequired,
};

BulkOperationResultContainer.defaultProps = {
  t: () => {},
  handleCloseModal: () => {},
  label: {
    success: '',
    glitch: '',
    failed: '',
  },
  handlePromise: () => {},
  glitchDetail: () => {},
};

export default BulkOperationResultContainer;
